exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Settings_page_1EJ_ {}\n\n.Settings_navigation_3B9k {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"page": "Settings_page_1EJ_",
	"navigation": "Settings_navigation_3B9k"
};